module.exports = __webpack_public_path__ + "img/pin-uncheck.b7831665.svg";